// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentNetStandardCasePrescriptionRelationshipModel {
    static getAttributeTypeMap() {
        return EnrollmentNetStandardCasePrescriptionRelationshipModel.attributeTypeMap;
    }
}
EnrollmentNetStandardCasePrescriptionRelationshipModel.discriminator = undefined;
EnrollmentNetStandardCasePrescriptionRelationshipModel.additionalProperties = false;
EnrollmentNetStandardCasePrescriptionRelationshipModel.attributeTypeMap = [
    {
        "name": "prescriptionId",
        "baseName": "prescriptionId",
        "type": "number"
    },
    {
        "name": "prescriberId",
        "baseName": "prescriberId",
        "type": "number"
    },
    {
        "name": "documentId",
        "baseName": "documentId",
        "type": "number"
    },
];
//# sourceMappingURL=enrollmentNetStandardCasePrescriptionRelationshipModel.js.map